import { gql } from "@apollo/client";

export const SNAPSHOT_FIELDS = gql`
  fragment SnapshotFields on SnapshotNode {
    createdTimestamp
    captureStart
    captureEnd
    name
    displayName
    state
    uid
    clearingCorridorMetricsCount
    bounds
  }
`;

export const SNAPSHOT_THUMBNAIL_FIELD = gql`
  fragment SnapshotThumbnailField on SnapshotNode {
    thumbnail
  }
`;

export const SNAPSHOT_DISPLAY_NAME = gql`
  fragment SnapshotDisplayName on SnapshotNode {
    displayName
  }
`;

export const SNAPSHOT_REGION_AGGREGATES = gql`
  fragment SnapshotRegionAggregates on SnapshotNode {
    regionAggregates {
      sumLineLengthKm
      sumTreeEncroachmentLengthM
      regionUid
      regionName
    }
  }
`;

export const MAST_FIELDS = gql`
  fragment MastFields on MastNode {
    sourceUid
    sourceName
    createdTimestamp
    displayName
    mastHeight
    retrievalDate
    sourceCreated
    sourceNetworkLevel
    sourceNetworkLevelName
    sourceUpdated
    uid
    updatedTimestamp
    geometry {
      coordinates
    }
  }
`;
